var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.hasImage
      ? _c(
          "div",
          { staticClass: "icon-image" },
          [
            _c("AImage", {
              attrs: {
                img: _vm.getImage,
                preset: _vm.getPreset,
                ratio: _vm.getRatio,
                contain: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "title" }, [
        _c("h3", [
          _vm._v("\n        " + _vm._s(_vm.getFeatureTitle) + "\n      "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "description",
        domProps: { innerHTML: _vm._s(_vm.getFeatureDescription) },
      }),
      _vm._v(" "),
      _vm.hasFeatureButton
        ? _c(
            "div",
            { staticClass: "action" },
            [
              _c(
                _vm.linkComponent,
                {
                  tag: "component",
                  attrs: {
                    to: { path: _vm.getFeatureButton.url },
                    href: _vm.$options.filters.toUrl(_vm.getFeatureButton.url),
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFeatureButton.title) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }